import React, { useContext } from "react";
import { ConfirmDialog, useNotifications } from "sprint-common-web";

import { OrderStatus } from "../../../common/types/OrderStatus";
import { useOrdersModuleApi } from "../../../common/useOrdersModuleApi";
import { OrderListingContext } from "../context/OrderListingContext";
import { OrderListingItem } from "../OrderListingItem";

type ReprocessOrderDialogProps = {
    isOpen: boolean;
    item: OrderListingItem;
    onCancel(): void;
    onSubmit(): void;
};

export const ReprocessOrderDialog: React.VFC<ReprocessOrderDialogProps> = ({
    item,
    isOpen,
    onCancel,
    onSubmit
}: ReprocessOrderDialogProps) => {
    const { updateOrder } = useContext(OrderListingContext);
    const { reprocessOrder } = useOrdersModuleApi();
    const { success, error } = useNotifications();

    const handleSubmit = async () => {
        try {
            await reprocessOrder({ orderId: item.id });
            updateOrder({ id: item.id, status: OrderStatus.Approved, isModified: true });
            onSubmit();
            success("Processing started");
        } catch {
            onCancel();
            error("Cannot reprocess order");
        }
    };

    return (
        <ConfirmDialog
            title="Reprocess order"
            text="Are you sure you want to reprocess order"
            hidden={!isOpen}
            confirm={{ onClick: handleSubmit }}
            cancel={{ onClick: onCancel }}
            width={500}
        />
    );
};
